//Get the distance from an element to the top of the document
export const getOffsetTop = function (elem) {
	// Set our distance placeholder
	var distance = 0;

	// Loop up the DOM
	if (elem.offsetParent) {
		do {
			distance += elem.offsetTop;
			elem = elem.offsetParent;
		} while (elem);
	}

	// Return our distance
	return distance < 0 ? 0 : distance;
};

//Check for Woocommerce URLs. Not particularly smart, so may need to change these URLs
export const isWoocommerceUrl = (url = '') => {
	const urlHasSubstring = (substring) => url.indexOf(substring) > -1;
	const substrings = ['/checkout', '/cart', '/product/', 'gifts/account'];
	return substrings.some(urlHasSubstring);
};

//Checks if link goes to default WP admin
export const isAdminUrl = (url = '') => {
	const urlHasSubstring = (substring) => url.indexOf(substring) > -1;
	const substrings = ['/wp-admin'];
	return substrings.some(urlHasSubstring);
};





// Check if main font has been loaded. Useful for removing preloader. Insert the name of the font to check instead of "Knockout"   !
export const checkFontsLoaded = (initFunction) =>{	
  var interval = null;
  function fontLoadListener() {
    var hasLoaded = false;
    try {
      hasLoaded = document.fonts.check('12px "Knockout"')
    } catch(error) {
      console.info("CSS font loading API error", error);
      fontLoadedSuccess();
      return;
    }
    
    if(hasLoaded) {
      fontLoadedSuccess();
    }
  }
  function fontLoadedSuccess() {
    if(interval) {
      clearInterval(interval);
    }

    initFunction();
  }

  interval = setInterval(fontLoadListener, 500);
}